<template>
  <cbm-card
    title="Reembolso"
    is-currency
    :number-text="value"
    number-color="#0A8533"
    number-width=""
    percent-description="a ser pago pela indústria"
    :tooltip="tooltip"
    simple-card
    :boolean-loader="loading"
  />
</template>

<script>
import CbmCard from '@/components/CbmCard.vue'
import { localeString } from '@/config/helpers.js'
import { rebateTooltip } from '@/modules/industria/helpers/rebateHelper.js'

export default {
  name: 'RebateCard',
  components: {
    CbmCard,
  },
  props: {
    loading: Boolean,
    offerType: {
      type: String,
      validator: (value) => ['takepay', 'nextbuycashback', 'dynamic_rule', 'general', 'crosssell', 'percentage'].includes(value),
    },
    metrics: {
      type: Object,
      default(_) {
        return {
          rebate: 0,
        }
      },
    },
  },
  computed: {
    value() {
      return localeString(this.metrics?.rebate, 2)
    },

    tooltip() {
      return rebateTooltip(this.offerType)
    },
  },
}
</script>
